'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactstrap = require('reactstrap');

var _ = require('../../');

require('./dropdown.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

//https://reactstrap.github.io/components/button-dropdown/

var GeckoDropdown = function (_Component) {
    _inherits(GeckoDropdown, _Component);

    function GeckoDropdown() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, GeckoDropdown);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = GeckoDropdown.__proto__ || Object.getPrototypeOf(GeckoDropdown)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            dropdownOpen: false
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(GeckoDropdown, [{
        key: 'toggle',
        value: function toggle() {
            this.setState({
                dropdownOpen: !this.state.dropdownOpen
            });
        }
    }, {
        key: 'renderMenuClasses',
        value: function renderMenuClasses() {
            var classes = ['shadow-sm rounded p-2', 'dropdown-menu-' + (this.props.align || 'right')];

            classes.push(_.GECKO_UTILS.prepareIndexClass('gecko-dropdown', this.props.index));

            return _.GECKO_UTILS.classNames(classes);
        }
    }, {
        key: 'renderItemClasses',
        value: function renderItemClasses(item, index) {
            var _GECKO_UTILS$classNam;

            return _.GECKO_UTILS.classNames((_GECKO_UTILS$classNam = {
                'dropdown-item': true,
                'dropdown-header': item.heading
            }, _defineProperty(_GECKO_UTILS$classNam, _.GECKO_UTILS.prepareNameClass('gecko-dropdown-item', item.name), item.name), _defineProperty(_GECKO_UTILS$classNam, _.GECKO_UTILS.prepareIndexClass('gecko-dropdown-item', index), true), _GECKO_UTILS$classNam));
        }
    }, {
        key: 'itemHandler',
        value: function itemHandler(item) {
            if (item.handler) {
                item.handler.bind(this, this.props.bind)();
            }
            return this.toggle();
        }
    }, {
        key: 'isHidden',
        value: function isHidden(item) {
            if (item.hideWhen) return item.hideWhen(this.props.bind);
            return false;
        }
    }, {
        key: 'renderItem',
        value: function renderItem(item, i) {
            if (this.isHidden(item)) {
                return null;
            }
            return _react2.default.createElement(
                'li',
                { className: this.renderItemClasses(item, i), onClick: this.itemHandler.bind(this, item), key: i },
                item.name
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            return _react2.default.createElement(
                _reactstrap.UncontrolledDropdown,
                { className: 'gecko-ui-dropdown', isOpen: this.state.dropdownOpen, toggle: this.toggle.bind(this) },
                _react2.default.createElement(
                    _reactstrap.DropdownToggle,
                    { tag: 'span' },
                    _react2.default.createElement(_.GeckoBtn, {
                        className: 'gecko-dropdown-toggle',
                        name: this.props.name,
                        ariaLabel: this.props.ariaLabel,
                        icon: this.props.icon,
                        type: this.props.type,
                        size: this.props.size,
                        preset: this.props.preset })
                ),
                _react2.default.createElement(
                    _reactstrap.DropdownMenu,
                    { tag: 'ul', className: this.renderMenuClasses() },
                    this.props.items.map(function (item, i) {
                        return _this2.renderItem(item, i);
                    })
                )
            );
        }
    }]);

    return GeckoDropdown;
}(_react.Component);

GeckoDropdown.defaultProps = {
    items: []
};

GeckoDropdown.propTypes = {
    items: _propTypes2.default.array
};

exports.default = GeckoDropdown;